import { render, staticRenderFns } from "./Hotsalebar.vue?vue&type=template&id=1d371c6c&scoped=true&"
import script from "./Hotsalebar.vue?vue&type=script&lang=js&"
export * from "./Hotsalebar.vue?vue&type=script&lang=js&"
import style0 from "./Hotsalebar.vue?vue&type=style&index=0&id=1d371c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d371c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VCard,VDivider,VImg,VRating})
